import React, { useEffect, useState, useMemo, useCallback } from 'react';
import {
    TextField, FormControl, InputLabel, Grid, Paper, Select, MenuItem,
    useMediaQuery, Button, FormHelperText, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Checkbox, Autocomplete, IconButton
} from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';

import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import Titlebar from '../TitleBar';
import { SaleOrderList } from '../TitleList';
import styled, { inputStyles } from '../../Utils/inputChanges';
import { useDispatch, useSelector } from 'react-redux';
import { getCurrentDate } from '../../Utils/Dateutils';
import { selectFirm, selectQTEntryNo, selectSalebarcd, selectsono, selectSOwiseParty } from '../Selectors/Master/ItemSelectors';
import { fetchCompanyData } from '../../Store/PHPSlice/Firm';
import { fetchSaleBarcode, fetchSOno, getPartyList, getQuotationEntryNo, insertSOquotwise } from '../../Store/PHPSlice/Sale/SaleOrder';
import CircularProgress from '@mui/material/CircularProgress';
import axios from 'axios';


const baseUrl = process.env.REACT_APP_BASE_URL;


const SOqtwise = () => {
    const userdata = JSON.parse(localStorage.getItem('user'));
    const [formData, setFormData] = useState({
        sono: '',
        quotNo: ' ',
        ordt: getCurrentDate(),
        firm: ' ',
        party: ' ',
        totqty: '0',
        itemNm: '',
        mclothNm: '',
        m1clothNm: '',
        m2clothNm: '',
        m3clothNm: '',
        qty: [],
        quotvalue: '',
        qItemNo: '',
        entry_type: '0',
        orgbarcode: '',
        barcode: '',
        orderNo: '',
        userId: userdata?.ID
    });
    const [itemData, setItemData] = useState({
        data: [],
        avgs: []
    });
    const [materialData, setMaterialData] = useState([]);
    const [MaterialLengths, setMaterialLengths] = useState([]);
    const [itemQuot, setItemQuot] = useState([]);

    const [qtyIndex, setQtyIndex] = useState([]);
    const [openTable, setOpenTable] = useState(false);
    const [entries, setEntries] = useState([]);
    const [selectedRows, setSelectedRows] = useState(new Set());
    const [selectedMaterials, setSelectedMaterials] = useState([]);
    const [priceListType, setPriceListType] = useState('');
    const [priceClothList, setPriceClothList] = useState([]);
    const [priceCloth, setPriceCloth] = useState('');
    const [priceListRates, setPriceListRates] = useState([]);
    const [sizeRateMap, setSizeRateMap] = useState({});
    const [quotationRates, setQuotationRates] = useState([]);

    const isQuotationSelected = Boolean(formData.quotNo);
    const isPriceListSelected = Boolean(priceListType && priceCloth);

    const [openMatPreview, setOpenMatPreview] = useState(false);
    const [previewMaterials, setPreviewMaterials] = useState([]);
    const [loading, setLoading] = useState(false);

    const dispatch = useDispatch();
    const firmlist = useSelector(selectFirm);
    const partylist = useSelector(selectSOwiseParty);
    const quotlist = useSelector(selectQTEntryNo);
    const sono = useSelector(selectsono);
    const barcode = useSelector(selectSalebarcd);

    useEffect(() => {
        dispatch(fetchCompanyData());
        dispatch(fetchSOno());
        dispatch(fetchSaleBarcode());
        dispatch(getQuotationEntryNo());
    }, [dispatch]);

    useEffect(() => {
        if (sono) {
            const item = sono.data.SOno || '';
            setFormData(prevFormData => ({
                ...prevFormData,
                sono: item
            }));
        }
    }, [sono]);

    // console.log(quotlist);

    // useEffect(() => {
    //     if (formData.firm) {
    //         dispatch(getPartyList(formData.firm))
    //     }
    // }, [formData.firm, dispatch]);

    // useEffect(() => {
    //     if (formData.firm && formData.party) {
    //         const post = {
    //             firmId: formData.firm,
    //             partyId: formData.party
    //         };
    //         dispatch(getQuotationEntryNo(post));
    //     }
    // }, [formData.firm, formData.party, dispatch]);

    useEffect(() => {
        if (barcode?.data) {
            const bar = barcode?.data?.sobar;
            setFormData(prevFormData => ({
                ...prevFormData,
                barcode: prevFormData.barcode || bar,
                orgbarcode: bar
            }));
        }
    }, [barcode]);

    useEffect(() => {
        if (!formData.orderNo) return;

        const timer = setTimeout(async () => {
            checkAPithroughOrderNo(formData.orderNo);
        }, 500); // 500ms delay after typing stops

        return () => clearTimeout(timer); // cleanup
    }, [formData.orderNo]);


    const checkAPithroughOrderNo = async (id) => {
        try {
            const response = await axios.get(
                `${baseUrl}?apicall=validation_material_inwardNo&orderno=${id}`
            );

            // console.log(response.data);

            if (response.data.status === "exists") {
                alert(response.data.msg || "Order number already exists");
                // window.location.reload();
                setFormData(prev => ({
                    ...prev,
                    orderNo: ''
                }));
            }

        } catch (error) {
            console.error("error", error);
        }
    };

    const isDesktop = useMediaQuery('(min-width:768px)');
    const handleMaterialPreview = (materials) => {
        const child = window.open("", "_blank", "width=1200,height=650");

        if (!child) return;

        child.document.write(`
  <html>
  <head>
    <title>Material Preview</title>
    <style>
      body {
        font-family: Calibri, Arial, sans-serif;
        padding: 20px;
      }

      table {
        width: 100%;
        border-collapse: collapse;
        margin-bottom: 35px;
      }

      th, td {
        border: 1px solid #444;
        padding: 6px 8px;
        text-align: center;
        font-size: 14px;
      }

      th {
        background: #d9d9d9;
        font-weight: bold;
      }

      .mat-name {
        font-weight: bold;
        background: #efefef;
        text-align: left;
        padding-left: 10px;
        width: 160px;
      }

      .row-label {
        background: #f2f2f2;
        font-weight: bold;
        text-align: left;
        width: 120px;
      }

      .inch-row {
        background: #e8f5e9;
        color: #1b5e20;
        font-weight: 600;
      }

      .mtr-row {
        background: #fff3e0;
        color: #e65100;
        font-weight: 600;
      }

      .total-col {
        font-weight: bold;
        background: #eeeeee;
      }

      h2 {
        margin-bottom: 20px;
      }
    </style>
  </head>

  <body>
    <h2>Selected Material Details</h2>

    ${materials.map(mat => {
            const totalInch = mat.totalInch;
            const totalMtr = mat.totalMtr;
            const totmqty = mat.totmqty;
            const reqmqty = mat.totreqmqty;
            return `
        <table>
          <thead>
            <tr>
              <th>Material Name</th>
              <th>Size</th>
              ${mat.sizes.map(s => `<th>${s.size}</th>`).join("")}
              <th>Total</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td class="mat-name" rowspan="6">
                ${mat.matNm}<br/>
                <small>(${mat.mtype})</small>
              </td>
              <td class="row-label">Item Length</td>
              ${mat.sizes.map(s => `<td>${s.item_length}</td>`).join("")}
              <td></td>
            </tr>

            <tr>
              <td class="row-label">M. Given Qty</td>
              ${mat.sizes.map(s => `<td>${s.reqmqty}</td>`).join("")}
              <td class="total-col">${reqmqty}</td>
            </tr>

            <tr>
              <td class="row-label">Qty</td>
              ${mat.sizes.map(s => `<td>${s.qty}</td>`).join("")}
              <td></td>
            </tr>
             
             <tr>
              <td class="row-label">M. Qty</td>
              ${mat.sizes.map(s => `<td>${s.mqty}</td>`).join("")}
                <td class="total-col">${totmqty}</td>
            </tr>

            <tr class="inch-row">
              <td class="row-label">Inch</td>
              ${mat.sizes.map(s => `<td>${s.inch}</td>`).join("")}
              <td class="total-col">${totalInch}</td>
            </tr>

            <tr class="mtr-row">
              <td class="row-label">Mtr</td>
              ${mat.sizes.map(s => `<td>${s.mtr}</td>`).join("")}
              <td class="total-col">${totalMtr}</td>
            </tr>
          </tbody>
        </table>
        `;
        }).join("")
            }

  </body>
  </html>
  `);

        child.document.close();
    };

    const fetchQuotlistusingQuotNo = async (id) => {
        try {
            const res = await axios.get(`${baseUrl}?apicall=getQuotationlist_usingQuotNo&quotNo=${id}`);
            const firmparty = res.data?.data2;
            setFormData(prev => ({
                ...prev,
                firmNm: firmparty?.firmNm,
                partyNm: firmparty?.partyNm
            }));
            setItemQuot(res.data?.data);

        } catch (error) {
            console.log(error);
        }
    };

    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;
        setFormData(prevFormData => ({
            ...prevFormData,
            [dropdownType]: value
        }));

        if (dropdownType === 'quotNo' && value) {
            // const id = parseInt(value);
            // fetchGetData(id); // Fetch data when a quotation is selected
            // fetchMaterialData(id); // Fetch material data when a quotation is selected
            // setOpenTable(true);
            fetchQuotlistusingQuotNo(value);
        }

        if (dropdownType === "quotId2" && value) {
            const filterdata = itemQuot?.find(i => i.ID === value);
            setFormData(prev => ({
                ...prev,
                firm: filterdata?.firmId,
                party: filterdata?.partyId,
                // firmNm: filterdata?.firmNm,
                // partyNm: filterdata?.partyNm
            }));
            fetchGetData(value); // Fetch data when a quotation is selected
            // fetchMaterialData(id); // Fetch material data when a quotation is selected
            setOpenTable(true);
        }
    };
    const handleMaterialCheckbox = (matId) => {
        setSelectedMaterials(prev => {
            if (prev.includes(matId)) {
                return prev.filter(id => id !== matId); // uncheck
            } else {
                return [...prev, matId]; // check
            }
        });
    };
    const materialSizeLengthMap = useMemo(() => {
        const map = {};

        MaterialLengths.forEach(row => {
            if (!map[row.matId]) {
                map[row.matId] = {};
            }
            map[row.matId][row.size] = row.matsize;
        });

        return map;
    }, [MaterialLengths]);

    const materialSizeQtyMap = useMemo(() => {
        const map = {};

        MaterialLengths.forEach(row => {
            if (!map[row.matId]) {
                map[row.matId] = {};
            }
            map[row.matId][row.size] = row.qty;
        });

        return map;
    }, [MaterialLengths]);

    const fetchGetData = async (id) => {
        try {
            const response = await fetch(`${baseUrl}?apicall=getQuotationViewlist&quotId=${id}`);

            // Check if the response is OK (status code 200)
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            // Parse the response as JSON
            const data = await response.json();

            // Assuming the response has `data` and `avgs` arrays, as shown in your example
            const filteredData = data.avgs.map(item => ({
                size: item.size,
                mavg: item.mavg,
                rate: item.rate,
                mrp: item.mrp,
                m1avg: item.m1avg,
                m2avg: item.m2avg,
                m3avg: item.m3avg,
            }));


            // Now you can use filteredData for further processing or display in the table
            setItemData({ data: data.data, avgs: filteredData });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const handlePriceListTypeChange = (e) => {
        const value = e.target.value;
        const quotId = formData.quotNo;

        if (!quotId) {
            alert("Please select quotation first");
            return;
        }

        setPriceListType(value);
        setPriceCloth('');
        setPriceClothList([]);

        fetchPriceClothList(value, quotId);
    };

    const fetchPriceClothList = async (type, quotId) => {
        try {
            //alert("hi");
            //alert("tyoe"+type);
            //alert("q=>"+quotId);
            if (!type || !quotId) return;

            const res = await fetch(
                `${baseUrl}?apicall=getPriceListCloth&type=${type}&quotId=${quotId}`
            );

            const result = await res.json();
            // console.log("result=>", result);

            // 👇 data is array of { cloth_name }
            setPriceClothList(result?.data || []);
        } catch (err) {
            console.error(err);
            setPriceClothList([]);
        }
    };
    // const handlePriceClothChange = (e) => {
    //     const value = e.target.value;
    //     setPriceCloth(value);
    //     fetchPriceListRates(value);
    // };
    const handlePriceClothChange = async (e) => {
        const cloth = e.target.value;
        setPriceCloth(cloth);

        if (!cloth || !priceListType || !formData.quotNo) return;

        try {
            const res = await fetch(
                `${baseUrl}?apicall=getPriceListRates&type=${priceListType}&clothName=${cloth}&quotId=${formData.quotNo}`
            );

            const result = await res.json();
            // console.log("pricelist=>",result);

            // ✅ SAFETY CHECK
            const priceList = Array.isArray(result?.data)
                ? result.data
                : [];

            // convert to size-wise format
            const sizeWiseRates = priceList.map(r => ({
                size: r.size,
                rate: r.rate
            }));

            // ✅ set pricelist rates
            setPriceListRates(sizeWiseRates);

            // clear quotation rates
            setQuotationRates([]);

            // update table data
            setItemData(prev => ({
                ...prev,
                avgs: sizeWiseRates
            }));
        } catch (err) {
            console.error("PriceList rate error", err);
        }
    };

    const fetchPriceListRates = async (clothName) => {
        try {
            const quotId = formData.quotNo;
            alert("quotId=>" + quotId);
            alert("clothName=>" + clothName);
            alert("priceListType=>" + priceListType);

            if (!clothName || !priceListType || !quotId) return;

            const res = await fetch(
                `${baseUrl}?apicall=getPriceListRates&type=${priceListType}&clothName=${clothName}&quotId=${quotId}`
            );

            const result = await res.json();
            // expected: [{ size: "38", rate: 120 }, ...]
            // console.log("resulr=>", result);

            setPriceListRates(result?.data || []);

            // 🔥 UPDATE RATE IN TABLE
            setItemData(prev => ({
                ...prev,
                avgs: prev.avgs.map(row => {
                    const matched = result?.data?.find(r => r.size === row.size);
                    return {
                        ...row,
                        rate: matched ? matched.rate : row.rate
                    };
                })
            }));
        } catch (err) {
            console.error("Price list rate error", err);
        }
    };


    const fetchMaterialData = async (id) => {
        try {
            const response = await fetch(
                `${baseUrl}?apicall=getMateriallist&quotId=${id}`
            );

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const data = await response.json();

            // material list only
            setMaterialData(data.data || []);
            setMaterialLengths(data.item_length || []); // ✅ NEW STATE


        } catch (error) {
            console.error('Error fetching material data:', error);
        }
    };
    const selectedMaterialObjects = useMemo(() => {
        return materialData.filter(mat =>
            selectedMaterials.includes(mat.matId)
        );
    }, [materialData, selectedMaterials]);
    const handleAddClick = () => {
        // Add the current form data to the entries array
        // if (selectedMaterialObjects.length === 0) {
        //     alert("Please select at least one material");
        //     return;
        // }

        checkAPithroughOrderNo(formData.orderNo);
        const newEntries = convertIntoOneObject(itemData, formData, selectedMaterialObjects, priceListType, priceCloth);
        setEntries(prevEntries => [...prevEntries, newEntries]);
        // Reset the form data to the initial state
        const newTotqty = entries.reduce((sum, item) => sum + item.totqty, 0) + newEntries.totqty;

        setFormData(prev => ({
            ...prev,
            quotNo: '',
            quotId2: '',
            qty: [],
            totqty: newTotqty,
            barcode: parseInt(prev.barcode, 10) + 1,
            extra_rate: 0
        }));
        setSelectedMaterials([]); // ✅ reset

        setOpenTable(false);

        setPriceCloth('');
        setPriceListType([]);
        // toast.success('Data added successfully');
    };

    // console.log(qtyIndex);
    function convertIntoOneObject(itemData, formData, materials, priceListType, priceCloth) {
        const totarr = qtyIndex?.map(item => formData.qty[item]);
        const sumqty = totarr?.reduce((sum, qty) => sum + parseInt(qty) || 0, 0);
        if (itemData.data.length > 0) {
            var quotno = itemData.data[0].quotNo || '';
            var qItemNo = itemData.data[0].qItemNo || '';
            var itemNm = itemData.data[0].itemNm || '';
            var mclothNm = itemData.data[0].clothNm || '';
            var m1clothNm = itemData.data[0].m1cloth || '';
            var m2clothNm = itemData.data[0].m2cloth || '';
            var m3clothNm = itemData.data[0].m3cloth || '';
            var itemId = itemData.data[0].itemId || '';
            var schlId = itemData.data[0].schoolId || '';
            var mainId = itemData.data[0].clothId || '';
            var m1Id = itemData.data[0].m1 || '';
            var m2Id = itemData.data[0].m2 || '';
            var m3Id = itemData.data[0].m3 || '';
        }

        const sizearr = itemData.avgs.map(item => item.size);
        const ratearr = itemData.avgs.map(item => item.rate);
        const mavgarr = itemData.avgs.map(item => item.mavg);
        const m1avgarr = itemData.avgs.map(item => item.m1avg);
        const m2avgarr = itemData.avgs.map(item => item.m2avg);
        const m3avgarr = itemData.avgs.map(item => item.m3avg);

        return {
            size: qtyIndex?.map(item => sizearr[item]),
            rate: qtyIndex?.map(item => ratearr[item]),
            mavg: qtyIndex?.map(item => mavgarr[item]),
            m1avg: qtyIndex?.map(item => m1avgarr[item]),
            m2avg: qtyIndex?.map(item => m2avgarr[item]),
            m3avg: qtyIndex?.map(item => m3avgarr[item]),
            quotationNo: `${quotno}-${itemNm}`,
            particular: `${formData.barcode} - ${itemNm} ${mclothNm} ${m1clothNm !== '0' ? m1clothNm : ''} ${m2clothNm !== '0' ? m2clothNm : ''} ${m3clothNm !== '0' ? m3clothNm : ''}`,
            qty: qtyIndex?.map(item => formData.qty[item]),
            totqty: sumqty,
            // quotId: formData.quotNo,
            quotId: formData.quotId2,
            itemId: itemId,
            schoolId: schlId,
            clothId: mainId,
            m1Id: m1Id,
            m2Id: m2Id,
            m3Id: m3Id,
            barcode: formData.barcode,
            itemNm: itemNm,
            mclothNm: mclothNm,
            m1clothNm: m1clothNm,
            m2clothNm: m2clothNm,
            m3clothNm: m3clothNm,
            priceListType: priceListType,
            priceCloth: priceCloth,
            extra_rate: formData.extra_rate,
            // ✅ ADD THIS
            materials: materials.map(mat => {

                // 🔹 SIZE-WISE DETAILS
                const sizeDetails = itemData.avgs.map((item, i) => {
                    const qty = Number(formData.qty[i] || 0);
                    const item_length = parseFloat(
                        materialSizeLengthMap?.[mat.matId]?.[item.size] || 0
                    );
                    const matsizeqty = parseFloat(materialSizeQtyMap?.[mat.matId]?.[item.size] || 0);

                    let inch = 0;
                    let mtr = 0;
                    let mqty = 0;
                    const singleMatlength = matsizeqty * item_length;
                    if (mat.mtype === "Pcs") {
                        mqty = qty * matsizeqty;
                    }
                    if (mat.mtype === "Mtr") {
                        mtr = qty * singleMatlength;
                        inch = 39.3701 * mtr;
                        mqty = qty * matsizeqty;
                    }
                    if (mat.mtype === "Inch") {
                        inch = qty * singleMatlength;
                        mtr = inch / 39.3701;
                        mqty = qty * matsizeqty;
                    }

                    return {
                        size: item.size,
                        qty: qty,
                        mqty: mqty.toFixed(2),
                        item_length: item_length,
                        inch: inch.toFixed(2),
                        mtr: mtr.toFixed(2),
                        reqmqty: matsizeqty
                    };
                });

                // 🔹 TOTALS
                const totalQty = sizeDetails.reduce((s, r) => s + r.qty, 0);
                const totalInch = sizeDetails.reduce((s, r) => s + parseFloat(r.inch), 0);
                const totalMtr = sizeDetails.reduce((s, r) => s + parseFloat(r.mtr), 0);
                const totmqty = sizeDetails.reduce((s, r) => s + parseFloat(r.mqty), 0);
                const reqmqty = sizeDetails.reduce((s, r) => s + parseFloat(r.reqmqty), 0);
                return {
                    matId: mat.matId,
                    matNm: mat.matNm,
                    mtype: mat.mtype,

                    // 🔹 SIZE-WISE DATA (IMPORTANT)
                    sizes: sizeDetails,

                    // 🔹 TOTALS
                    totalQty: totalQty,
                    totalInch: totalInch.toFixed(2),
                    totalMtr: totalMtr.toFixed(2),
                    totmqty: totmqty.toFixed(2),
                    totreqmqty: reqmqty.toFixed(2),
                };
            })


        };
    };

    function finalObject(entries, formData) {
        const final = {
            sono: formData.sono,
            orderNo: formData.orderNo,
            ordt: formData.ordt,
            totqty: formData.totqty,
            firm: formData.firm,
            party: formData.party,
            entry_type: formData.entry_type,
            userId: formData.userId,
            entries: entries
        }
        return final;
    }
    const handleQtyChange = (index, value) => {
        setQtyIndex(prev => {
            // Add the index only if it is not already present
            if (!prev.includes(index)) {
                return [...prev, index];
            }
            return prev;
        });
        setFormData(prevFormData => {
            const newQty = [...prevFormData.qty];
            newQty[index] = value;
            return { ...prevFormData, qty: newQty };
        });
    };

    const handleCheckboxChange = (index) => {
        setSelectedRows(prevSelectedRows => {
            const newSelectedRows = new Set(prevSelectedRows);
            if (newSelectedRows.has(index)) {
                newSelectedRows.delete(index);
            } else {
                newSelectedRows.add(index);
            }
            return newSelectedRows;
        });
    };

    const handleRemoveClick = () => {
        setEntries(prevEntries => {
            // Step 1: Filter entries to keep (i.e., not selected)
            const remainingEntries = prevEntries.filter((_, index) => !selectedRows.has(index));
            // Log the data of the selected rows
            const selectedData = prevEntries.filter((_, index) => selectedRows.has(index));
            // console.log("Selected rows data:", selectedData);

            // Calculate the total quantity from the selected rows
            const totalQtyToRemove = selectedData.reduce((acc, item) => acc + parseInt(item.totqty, 10), 0);

            const baseBarcode = parseInt(formData.orgbarcode, 10); // You can change this to match your logic
            const updatedEntries = remainingEntries.map((item, i) => ({
                ...item,
                barcode: `${baseBarcode + i}`, // e.g., '10001', '10002', etc.
                particular: `${baseBarcode + i} - ${item.itemNm} ${item.mclothNm} ${item.m1clothNm !== '0' ? item.m1clothNm : ''} ${item.m2clothNm !== '0' ? item.m2clothNm : ''} ${item.m3clothNm !== '0' ? item.m3clothNm : ''}`,
            }));

            // Set the last barcode value
            const latestBar = updatedEntries.length > 0 ? `${baseBarcode + updatedEntries.length}` : formData.orgbarcode;

            // Update the formdata.totqty by subtracting the totalQtyToRemove
            setFormData(prevFormData => ({
                ...prevFormData,
                totqty: parseInt(prevFormData.totqty, 10) - totalQtyToRemove || '0',
                barcode: latestBar
            }));
            // console.log(updatedEntries);
            // Filter out the selected rows
            return updatedEntries;
        });

        setSelectedRows(new Set()); // Clear the selected rows
    };

    const handleDateChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevFormData => ({ ...prevFormData, [name]: value }));
    };
    const tableContainerStyle = {
        marginTop: '1%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',
        overflowY: 'hidden',
        WebkitOverflowScrolling: 'touch',
    };
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevFormData => ({ ...prevFormData, [name]: value.toUpperCase() }));

        if (name === 'extra_rate') {
            const extra = Number(value);

            setItemData(prev => ({
                ...prev,
                avgs: prev.avgs.map(item => {
                    const base = item.baseRate ?? item.rate; // fallback

                    return {
                        ...item,
                        baseRate: base,               // ensure it's stored
                        rate: Number(base) + extra
                    };
                })
            }));
        }

    };
    // console.log(itemData)

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (formData.orderNo.trim() !== "") {
            setLoading(true);
            try {
                const finalObj = finalObject(entries, formData);
                // console.log(finalObj);
                const result = await dispatch(insertSOquotwise(finalObj)).unwrap();
                console.log('POST request successful!', result);
                alert("Sale Order Added Successfully....!!!");
                window.location.reload();
            } catch (error) {
                console.error('Error while making POST request:', error);
            } finally {
                setLoading(false);
            }
        } else {
            alert('Order Number Empty');
        }


    };

    // console.log('priceCloth', priceCloth, 'priceListType', priceListType);
    const getItemLength = (matId, size) => {
        return Number(materialSizeLengthMap?.[matId]?.[size] || 0);
    };

    const getQty = (index) => {
        return Number(formData.qty[index] || 0);
    };
    const isLengthType = (mtype) =>
        mtype === 'Inch' || mtype === 'Mtr' || mtype == 'Roll';

    const calcInch = (matId, size, index, mtype) => {
        if (!isLengthType(mtype)) return "0.00";

        return (
            getItemLength(matId, size) * getQty(index)
        ).toFixed(2);
    };

    const calcMtr = (matId, size, index, mtype) => {
        if (!isLengthType(mtype)) return "0.000";

        return (
            (getItemLength(matId, size) * getQty(index)) / 39
        ).toFixed(3);
    };
    const calcTotalInch = (matId, mtype) => {
        if (!isLengthType(mtype)) return "0.00";

        return itemData.avgs.reduce((sum, item, i) => {
            const qty = Number(formData.qty[i] || 0);
            const len = Number(materialSizeLengthMap?.[matId]?.[item.size] || 0);
            return sum + qty * len;
        }, 0).toFixed(2);
    };


    const calcTotalMtr = (matId, mtype) => {
        //  alert("mtype=>",mtype);
        if (!isLengthType(mtype)) return "0.000";

        return (calcTotalInch(matId, mtype) / 39).toFixed(3);
    };

    const handleExtraChange = (index, value) => {
        const extra = Number(value || 0);

        setItemData(prev => ({
            ...prev,
            avgs: prev.avgs.map((item, i) => {
                if (i !== index) return item;
                return {
                    ...item,
                    rate: extra
                };
            })
        }));
    };


    // console.log(entries);

    return (
        <>
            <Titlebar data={SaleOrderList} />
            <div style={{ margin: '1% 0.5%' }}>
                <h2>Sale Order Entry - Quotation No. Wise</h2>
                <Grid container>
                    <Grid item>
                        <Paper style={{ padding: '2vh', paddingLeft: '2%' }}>
                            <Grid container spacing={0.5} >

                                {/* <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '25%' } : { width: '100%' }}>
                                            <InputLabel id="firm">Firm:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth >
                                                <Autocomplete
                                                    id="firm"
                                                    options={firmlist.data}
                                                    getOptionLabel={(option) => option.firmNm || ''} // Ensure this returns the correct label
                                                    value={firmlist.data.find(firm => firm.ID === formData.firm) || null} // Ensure this returns the full object
                                                    onChange={(event, newValue) => handleDropdownChange({ target: { name: 'firm', value: newValue ? newValue.ID : '' } }, 'firm')}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            variant="outlined"
                                                            placeholder='Select Option'
                                                            sx={{
                                                                ...inputStyles,
                                                                '& .MuiInputBase-root': {
                                                                    height: '35px', // Set your desired height here
                                                                },
                                                            }}
                                                        />
                                                    )}
                                                />
                                                {errors.firm && <FormHelperText style={errorStyles}>{errors.firm}</FormHelperText>}
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '25%' } : { width: '100%' }}>
                                            <InputLabel id="party">Party:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth >
                                                <Autocomplete
                                                    id="party"
                                                    options={partylist?.data || []} // Use optional chaining and provide an empty array if undefined
                                                    getOptionLabel={(option) => option.partyNm || ''} // Ensure this returns the correct label
                                                    value={partylist?.data?.find(party => party.ID === formData.party) || null} // Check if partylist.data is defined
                                                    onChange={(event, newValue) => handleDropdownChange({ target: { name: 'party', value: newValue ? newValue.ID : '' } }, 'party')}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            variant="outlined"
                                                            placeholder='Select Option'
                                                            sx={{
                                                                ...inputStyles,
                                                                '& .MuiInputBase-root': {
                                                                    height: '35px', // Set your desired height here
                                                                },
                                                            }}
                                                        />
                                                    )}
                                                />

                                                {errors.party && <FormHelperText style={errorStyles}>{errors.party}</FormHelperText>}
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid> */}

                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '25%' } : { width: '100%' }}>
                                            <InputLabel id="quotNo">Quotation No:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth >
                                                <Autocomplete
                                                    id="quotNo"
                                                    options={quotlist?.quotlist || []}

                                                    getOptionLabel={(option) => `${option.quotNo}` || ''} // Ensure this returns the correct label
                                                    value={quotlist?.quotlist?.find(quot => quot.ID === formData.quotNo) || null} // Ensure this returns the full object
                                                    onChange={(event, newValue) => handleDropdownChange({ target: { name: 'quotNo', value: newValue ? newValue.ID : '' } }, 'quotNo')}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            variant="outlined"
                                                            placeholder='Select Option'
                                                            sx={{
                                                                ...inputStyles,
                                                                '& .MuiInputBase-root': {
                                                                    height: '35px', // Set your desired height here
                                                                },
                                                            }}
                                                        />
                                                    )}
                                                />
                                                {/* {errors.quotNo && <FormHelperText style={errorStyles}>{errors.quotNo}</FormHelperText>} */}
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                {/* { label: 'Extra Rate', name: 'extra_rate' }, */}
                                {[
                                    { label: 'Order Date', name: 'ordt', type: 'date' },
                                    { label: 'SO No', name: 'sono', type: 'readOnly' },
                                    { label: 'Barcode', name: 'barcode', type: 'readOnly' },
                                    { label: 'Order No.', name: 'orderNo' },
                                    { label: 'Total Qty', name: 'totqty', type: 'readOnly' },
                                    { label: 'Firm', name: 'firmNm', type: 'readOnly' },
                                    { label: 'Party', name: 'partyNm', type: 'readOnly' },
                                    { label: 'Instruction', name: 'instruction' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '25%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    {field.type === 'date' ? (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            type="date"
                                                            value={formData[field.name]}
                                                            onChange={handleDateChange}
                                                            inputProps={{ style: styled.inputDate }}
                                                            sx={inputStyles}
                                                        />
                                                    ) : (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            value={formData[field.name] || ''}
                                                            onChange={handleInputChange}
                                                            inputProps={{ style: styled.input, readOnly: field.type === 'readOnly' }}
                                                            sx={inputStyles}
                                                        />
                                                    )}

                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}
                                {/* PRICE LIST - below Order No */}

                                {/* <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item xs={3}>
                                            <InputLabel>Price List : </InputLabel>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <FormControl fullWidth size="small">
                                                <Select
                                                    value={priceListType}
                                                    onChange={handlePriceListTypeChange}
                                                    displayEmpty
                                                    style={{ width: '240px' }}
                                                >
                                                    <MenuItem value="">Select</MenuItem>
                                                    <MenuItem value="MU">MU</MenuItem>
                                                    <MenuItem value="S">S</MenuItem>
                                                    <MenuItem value="N">N</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid> */}
                                {/* CLOTH NAME - below Total Qty */}

                                {/* <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item xs={3}>
                                            <InputLabel>PriceList Cloth Name</InputLabel>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <FormControl fullWidth size="small" disabled={!priceListType || priceClothList.length === 0}>
                                                <Select
                                                    value={priceCloth}
                                                    onChange={handlePriceClothChange}
                                                    displayEmpty
                                                    style={{ width: '240px' }}
                                                >

                                                    <MenuItem value="">Select</MenuItem>
                                                    {priceClothList.map((row, index) => (
                                                        <MenuItem key={index} value={row.cloth_name}>
                                                            {row.cloth_name}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid> */}

                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '25%' } : { width: '100%' }}>
                                            <InputLabel id="quotId2">Item:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth >
                                                <Autocomplete
                                                    id="quotId2"
                                                    options={
                                                        entries?.length
                                                            ? itemQuot?.filter((item) =>
                                                                entries.some((entry) => entry.quotId !== item.ID)
                                                            )
                                                            : itemQuot || []
                                                    }

                                                    getOptionLabel={(option) => `${option.quotNo}-${option.itemNm}` || ''} // Ensure this returns the correct label
                                                    value={itemQuot?.find(quot => quot.ID === formData.quotId2) || null} // Ensure this returns the full object
                                                    onChange={(event, newValue) => handleDropdownChange({ target: { name: 'quotId2', value: newValue ? newValue.ID : '' } }, 'quotId2')}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            variant="outlined"
                                                            placeholder='Select Option'
                                                            sx={{
                                                                ...inputStyles,
                                                                '& .MuiInputBase-root': {
                                                                    height: '35px', // Set your desired height here
                                                                },
                                                            }}
                                                        />
                                                    )}
                                                />
                                                {/* {errors.quotNo && <FormHelperText style={errorStyles}>{errors.quotNo}</FormHelperText>} */}
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                {openTable === true &&
                                    <>
                                        <Grid item xs={12} md={12}>
                                            <h3 style={{ marginTop: '10px' }}>Sale Order Details</h3>
                                            <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle, display: 'flex' }}>
                                                <Table style={{ width: '70%' }}>
                                                    <TableHead>
                                                        <TableRow className='tbl-row'>
                                                            <TableCell sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }} align='center'>Particulars</TableCell>

                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        <TableRow>
                                                            {itemData.data.length > 0 && itemData.data.map((item) => (
                                                                <TableCell sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }} align='center'>
                                                                    {item.itemNm}<br />{item.clothNm}<br /> {item.m1cloth !== '0' && item.m1cloth}<br />
                                                                    &nbsp;{item.m2cloth !== '0' && item.m2cloth}<br /> {item.m3cloth !== '0' && item.m3cloth}</TableCell>
                                                            ))}
                                                        </TableRow>

                                                    </TableBody>
                                                </Table>
                                                <Table>
                                                    <TableHead>
                                                        <TableRow className='tbl-row'>
                                                            <TableCell sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }} align='center'>Size</TableCell>
                                                            {itemData.avgs.length > 0 ? itemData.avgs.map((item, index) => (
                                                                <TableCell key={index} sx={{ p: 0.4, border: '1px solid #000' }} align='center'>{item.size}</TableCell>
                                                            )) : ''}
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        <TableRow>
                                                            <TableCell sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }} align='center'>Rate</TableCell>

                                                            {itemData.avgs ? itemData.avgs.map((item, index) => (
                                                                <TableCell key={index} sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                                    {/* <input
                                                                        type="number"
                                                                        value={item.rate || ""}
                                                                        onChange={(e) => handleExtraChange(index, e.target.value)}
                                                                        style={{ width: '50px', padding: '1px' }}
                                                                    /> */}
                                                                    {item.rate}
                                                                </TableCell>
                                                            )) : ''}
                                                        </TableRow>

                                                        <TableRow>
                                                            <TableCell sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }} align='center'>Qty</TableCell>

                                                            {itemData.avgs.length > 0 ? itemData.avgs.map((item, index) => (
                                                                <TableCell align='center' sx={{ p: 0.4, border: '1px solid #000' }} key={index}>
                                                                    <input
                                                                        type="text"
                                                                        value={formData.qty[index] || '0'}
                                                                        onChange={(e) => handleQtyChange(index, e.target.value)}
                                                                        style={{ width: '50px', padding: '1px' }}
                                                                    />
                                                                </TableCell>
                                                            )) : ''}
                                                        </TableRow>
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </Grid>

                                        {/* {materialData.length > 0 && (
                                            <Grid item xs={10} md={10}>

                                                {materialData.length > 0 && (
                                                    <Grid item xs={14} md={14}>
                                                        <h3 style={{ marginTop: '10px' }}>Material Details</h3>

                                                        <TableContainer
                                                            component={Paper}
                                                            sx={{
                                                                width: "100%",
                                                                overflowX: "auto",
                                                                mt: 2,
                                                                border: "1px solid #999"
                                                            }}
                                                        >
                                                            <Table sx={{ minWidth: 1400 }} size="small">

                                                                <TableHead>
                                                                    <TableRow className='tbl-row'>
                                                                        <TableCell align="center" style={{ border: "1px solid #000" }}>Select</TableCell>
                                                                        <TableCell align="center" style={{ border: "1px solid #000" }}>Sr No</TableCell>
                                                                        <TableCell align="center" style={{ border: "1px solid #000" }}>Department</TableCell>
                                                                        <TableCell align="center" style={{ border: "1px solid #000" }}>Material Name</TableCell>
                                                                        <TableCell align="center" style={{ border: "1px solid #000" }}>M.Size Type</TableCell>
                                                                        <TableCell align="center" style={{ border: "1px solid #000" }}>Size</TableCell>
                                                                        {itemData.avgs.map((item, index) => (
                                                                            <TableCell key={index} align="center" style={{ border: "1px solid #000" }}>
                                                                                {item.size}
                                                                            </TableCell>
                                                                        ))}
                                                                        <TableCell align="right" style={{ border: "1px solid #000", fontWeight: "bold" }}>
                                                                            Total
                                                                        </TableCell>
                                                                    </TableRow>
                                                                </TableHead>


                                                                <TableBody>
                                                                    {materialData.map((mat, index) => (
                                                                        <React.Fragment key={mat.matId}>

                                                                            <TableRow>
                                                                                <TableCell align="center" style={{ borderTop: "1px solid #000", borderBottom: "1px solid #fff" }}>
                                                                                    <Checkbox
                                                                                        checked={selectedMaterials.includes(mat.matId)}
                                                                                        onChange={() => handleMaterialCheckbox(mat.matId)}
                                                                                    />
                                                                                </TableCell>

                                                                                <TableCell align="center" style={{ borderTop: "1px solid #000", borderBottom: "1px solid #fff" }}>{index + 1}</TableCell>
                                                                                <TableCell align="center" style={{ borderTop: "1px solid #000", borderBottom: "1px solid #fff" }}>{mat.departNm}</TableCell>
                                                                                <TableCell align="center" style={{ borderTop: "1px solid #000", borderBottom: "1px solid #fff" }}>{mat.matNm}</TableCell>
                                                                                <TableCell align="center" style={{ borderTop: "1px solid #000", borderBottom: "1px solid #fff" }}>{mat.mtype}</TableCell>
                                                                                <TableCell align="center" style={{ borderTop: "1px solid #000", borderBottom: "1px solid #000" }}>Item Length</TableCell>

                                                                                {itemData.avgs.map((item, i) => (
                                                                                    <TableCell
                                                                                        key={i}
                                                                                        align="center"
                                                                                        style={{ border: "1px solid #000" }}
                                                                                    >
                                                                                        {materialSizeLengthMap?.[mat.matId]?.[item.size] || 0}
                                                                                    </TableCell>
                                                                                ))}
                                                                            </TableRow>
                                                                            <TableRow>
                                                                                <TableCell style={{ borderTop: "1px solid #000", borderBottom: "1px solid #fff" }} />
                                                                                <TableCell style={{ borderTop: "1px solid #000", borderBottom: "1px solid #fff" }} />
                                                                                <TableCell style={{ borderTop: "1px solid #000", borderBottom: "1px solid #fff" }} />
                                                                                <TableCell style={{ borderTop: "1px solid #000", borderBottom: "1px solid #fff" }} />
                                                                                <TableCell style={{ borderTop: "1px solid #000", borderBottom: "1px solid #fff" }} />
                                                                                <TableCell align="center" style={{ border: "1px solid #000" }}>
                                                                                    Qty
                                                                                </TableCell>

                                                                                {itemData.avgs.map((_, i) => (
                                                                                    <TableCell
                                                                                        key={i}
                                                                                        align="center"
                                                                                        style={{ border: "1px solid #000", color: "#0d47a1" }}
                                                                                    >
                                                                                        {formData.qty[i] || 0}
                                                                                    </TableCell>
                                                                                ))}
                                                                                <TableCell style={{ borderTop: "1px solid #000", borderBottom: "1px solid #000" }}></TableCell>
                                                                            </TableRow>
                                                                            <TableRow>
                                                                                <TableCell style={{ borderTop: "1px solid #000", borderBottom: "1px solid #fff" }} />
                                                                                <TableCell style={{ borderTop: "1px solid #000", borderBottom: "1px solid #fff" }} />
                                                                                <TableCell style={{ borderTop: "1px solid #000", borderBottom: "1px solid #fff" }} />
                                                                                <TableCell style={{ borderTop: "1px solid #000", borderBottom: "1px solid #fff" }} />
                                                                                <TableCell style={{ borderTop: "1px solid #000", borderBottom: "1px solid #fff" }} />
                                                                                <TableCell align="center" style={{ border: "1px solid #000" }}>
                                                                                    Inch
                                                                                </TableCell>

                                                                                {itemData.avgs.map((item, i) => (
                                                                                    <TableCell key={i} align="center" style={{ border: "1px solid #000", color: "#1b5e20", }}>
                                                                                        {calcInch(mat.matId, item.size, i, mat.mtype)}
                                                                                    </TableCell>
                                                                                ))}
                                                                                <TableCell colSpan={itemData.avgs.length} align="center" style={{ border: "1px solid #000", color: "green", fontWeight: "bold" }}>
                                                                                    <b>{calcTotalInch(mat.matId, mat.mtype)}</b>
                                                                                </TableCell>
                                                                            </TableRow>

                                                                            <TableRow>
                                                                                <TableCell />
                                                                                <TableCell />
                                                                                <TableCell />
                                                                                <TableCell />
                                                                                <TableCell />
                                                                                <TableCell align="center" style={{ border: "1px solid #000" }}>
                                                                                    Mtr
                                                                                </TableCell>

                                                                                {itemData.avgs.map((item, i) => (
                                                                                    <TableCell key={i} align="center" style={{ border: "1px solid #000", color: "#e65100" }}>
                                                                                        {calcMtr(mat.matId, item.size, i, mat.mtype)}
                                                                                    </TableCell>
                                                                                ))}
                                                                                <TableCell colSpan={itemData.avgs.length} align="center" style={{ border: "1px solid #000", color: "#ff0000", fontWeight: "bold" }}>
                                                                                    <b>{calcTotalMtr(mat.matId, mat.mtype)}</b>
                                                                                </TableCell>
                                                                            </TableRow>

                                                                            <TableRow>

                                                                            </TableRow>
                                                                            <TableRow>


                                                                            </TableRow>

                                                                        </React.Fragment>
                                                                    ))}
                                                                </TableBody>


                                                            </Table>
                                                        </TableContainer>
                                                    </Grid>
                                                )}

                                            </Grid>
                                        )} */}


                                        <Grid item xs={12}>
                                            <div style={{ margin: '1% 5%' }}>
                                                <Button variant="contained" color="primary" onClick={handleAddClick} disabled={formData.qty.length <= 0}>Add</Button>
                                            </div>
                                        </Grid>

                                    </>
                                }

                                <Grid item xs={12}>
                                    <Button variant="contained" color="primary" onClick={handleRemoveClick}>Remove</Button>
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                                        <Table>
                                            <TableHead>
                                                <TableRow className='tbl-row'>
                                                    <TableCell sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }} align='center'>Remove</TableCell>
                                                    <TableCell sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }} align='center'>Sr.No</TableCell>
                                                    <TableCell sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }} align='center'>Quotation No.</TableCell>
                                                    <TableCell sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }} align='center'>Particular</TableCell>
                                                    <TableCell sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }} align='center'>Size</TableCell>
                                                    <TableCell sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }} align='center'>Rate(Rs.)</TableCell>
                                                    <TableCell sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }} align='center'>Quantity</TableCell>
                                                    <TableCell sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }} align='center'>Total Qty</TableCell>
                                                    {/* <TableCell sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }} align='center'>Material</TableCell> */}

                                                </TableRow>
                                            </TableHead>
                                            {entries?.length > 0 ? entries?.map((val, index) => (
                                                <TableBody>

                                                    <TableCell sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }} align='center'>
                                                        <Checkbox
                                                            checked={selectedRows.has(index)}
                                                            onChange={() => handleCheckboxChange(index)}
                                                        />
                                                    </TableCell>
                                                    <TableCell sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }} align='center'>{index + 1}</TableCell>
                                                    <TableCell sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }} align='center'>{val.quotationNo}</TableCell>
                                                    <TableCell sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }} align='center'>{val.particular}</TableCell>
                                                    <TableCell sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }} align='center'>{val.size.join(',')}</TableCell>
                                                    <TableCell sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }} align='center'>{val.rate.join(',')}</TableCell>
                                                    <TableCell sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }} align='center'>{val.qty.join(',')}</TableCell>
                                                    <TableCell sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }} align='center'>{val.totqty}</TableCell>
                                                    {/* ✅ MATERIAL COLUMN */}
                                                    {/* <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align="center">
                                                        {val.materials?.length > 0 ? (
                                                            <IconButton
                                                                size="small"
                                                                onClick={() => handleMaterialPreview(val.materials, val.size, val.rate, val.qty)}
                                                            >
                                                                <VisibilityIcon />
                                                            </IconButton>
                                                        ) : (
                                                            "-"
                                                        )}
                                                    </TableCell> */}
                                                </TableBody>
                                            )) : ''}

                                        </Table>

                                    </TableContainer>
                                </Grid>


                                {entries?.length > 0 &&
                                    (<Grid item xs={12} textAlign="center">
                                        <Button variant="contained" color="primary" onClick={handleSubmit} disabled={loading === true}>
                                            {
                                                loading === true ?
                                                    <><CircularProgress size="20px" /> wait...</> :
                                                    "Submit"
                                            }
                                        </Button>
                                    </Grid>)}

                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>

            </div>
        </>
    );
}

export default SOqtwise;